module.exports = __webpack_public_path__ + "static/media/nsh.cab6d293.png";